import { DashboardIframeData } from "@/utils/dashboard/dashboard-iframe-data";

export class GeneralUserConfig {
	SelectedLang: string = "nl-be";
	NotifyOnFrequencyDocumentCreated:boolean = false;
	NotifyOnFrequencyDocumentSent:boolean = false;
	NotifyOnReminderSent:boolean = false;
	NotifyOnPeppolReceive:boolean = false;
	EmailNotifyOnPeppolReceive:boolean = false;
	PeppolNotificationEmail:string = "";
	RepeatBankSave:boolean = false;
	ShowSalesOrPurchasesInBankEdit:boolean = false;
	AutoAssignProductSku:boolean = false;
	AutoUpdateProductComposition:boolean = false;
	GetPurchasePriceFromProductWhenZero:boolean = false;
	UseCheckboxesInViews:boolean = false;
	CompactView:boolean = false;
	MaximizeEmailModal:boolean = false;
	DoubleClickOpensEdit:boolean = false;
	BanksOrder:number[] = [];
	NewCustommersAreBuisinessesByDefault:boolean = true;
	ShowSupplierFilterOnPriceListOpen:boolean = false;
	ToolbarIframe:DashboardIframeData = new DashboardIframeData();

	ClearF3SearchFilter:boolean = true
	DefaultProductsF3Browse:number = 0
	DefaultSalesF3Browse:number = 0
	DefaultSaleRowsF3Browse:number = 0
	DefaultBankSalesF3Browse:number = 0
	DefaultPurchaseF3Browse:number = 0
	DefaultPurchaseDocumentRowF3Browse:number = 0
	OpenModalInExternalTab: boolean = false
	ProductSearchSortOrder: number = 0

	// eslint-disable-next-line max-lines-per-function
	constructor(data: any) {
		if (!data) return;
		this.SelectedLang = data.SelectedLang;
		this.NotifyOnFrequencyDocumentCreated = data.NotifyOnFrequencyDocumentCreated;
		this.NotifyOnFrequencyDocumentSent = data.NotifyOnFrequencyDocumentSent;
		this.NotifyOnReminderSent = data.NotifyOnReminderSent;
		this.NotifyOnPeppolReceive = data.NotifyOnPeppolReceive;
		this.EmailNotifyOnPeppolReceive = data.EmailNotifyOnPeppolReceive;
		this.PeppolNotificationEmail = data.PeppolNotificationEmail || "";
		this.RepeatBankSave = data.RepeatBankSave;
		this.ShowSalesOrPurchasesInBankEdit = data.ShowSalesOrPurchasesInBankEdit == undefined ? false : data.ShowSalesOrPurchasesInBankEdit;
		this.AutoAssignProductSku = data.AutoAssignProductSku;
		this.AutoUpdateProductComposition = data.AutoUpdateProductComposition;
		this.GetPurchasePriceFromProductWhenZero = data.GetPurchasePriceFromProductWhenZero;
		this.UseCheckboxesInViews = data.UseCheckboxesInViews;
		this.CompactView = data.CompactView;
		this.MaximizeEmailModal = data.MaximizeEmailModal;
		this.DoubleClickOpensEdit = data.DoubleClickOpensEdit || false;
		this.ClearF3SearchFilter = data.ClearF3SearchFilter == undefined ? true : data.ClearF3SearchFilter;
		this.DefaultProductsF3Browse = data.DefaultProductsF3Browse;
		this.DefaultSalesF3Browse = data.DefaultSalesF3Browse;
		this.DefaultSaleRowsF3Browse = data.DefaultSaleRowsF3Browse;
		this.DefaultPurchaseF3Browse = data.DefaultPurchaseF3Browse;
		this.DefaultPurchaseDocumentRowF3Browse = data.DefaultPurchaseDocumentRowF3Browse;
		this.DefaultBankSalesF3Browse = data.DefaultBankSalesF3Browse;
		this.NewCustommersAreBuisinessesByDefault = data.NewCustommersAreBuisinessesByDefault;
		this.ShowSupplierFilterOnPriceListOpen = data.ShowSupplierFilterOnPriceListOpen || false;
		this.ToolbarIframe = new DashboardIframeData(data.ToolbarIframe);
		// Migrate old separate settings into ToolbarIframe
		if (data.ToolbarIframeWidthMode && !data.ToolbarIframe?.WidthMode) {
			this.ToolbarIframe.WidthMode = data.ToolbarIframeWidthMode;
		}
		if (data.ToolbarIframeFixedWidth && !data.ToolbarIframe?.FixedWidth) {
			this.ToolbarIframe.FixedWidth = data.ToolbarIframeFixedWidth;
		}
		this.OpenModalInExternalTab = data.OpenModalInExternalTab;
		this.ProductSearchSortOrder = data.ProductSearchSortOrder || 0;
		if (this.SelectedLang == "") {
			this.SelectedLang = "nl-be";
		}
		this.BanksOrder = [...(data.BanksOrder || [])];
	}

	getJSON() {
		return {
			SelectedLang: this.SelectedLang,
			NotifyOnFrequencyDocumentCreated: this.NotifyOnFrequencyDocumentCreated,
			NotifyOnFrequencyDocumentSent: this.NotifyOnFrequencyDocumentSent,
			NotifyOnReminderSent: this.NotifyOnReminderSent,
			NotifyOnPeppolReceive: this.NotifyOnPeppolReceive,
			EmailNotifyOnPeppolReceive: this.EmailNotifyOnPeppolReceive,
			PeppolNotificationEmail: this.PeppolNotificationEmail,
			RepeatBankSave: this.RepeatBankSave,
			ShowSalesOrPurchasesInBankEdit: this.ShowSalesOrPurchasesInBankEdit,
			AutoAssignProductSku: this.AutoAssignProductSku,
			AutoUpdateProductComposition: this.AutoUpdateProductComposition,
			GetPurchasePriceFromProductWhenZero: this.GetPurchasePriceFromProductWhenZero,
			UseCheckboxesInViews: this.UseCheckboxesInViews,
			CompactView: this.CompactView,
			MaximizeEmailModal: this.MaximizeEmailModal,
			DoubleClickOpensEdit: this.DoubleClickOpensEdit,
			ClearF3SearchFilter: this.ClearF3SearchFilter,
			DefaultProductsF3Browse: this.DefaultProductsF3Browse,
			DefaultSalesF3Browse: this.DefaultSalesF3Browse,
			DefaultSaleRowsF3Browse: this.DefaultSaleRowsF3Browse,
			DefaultBankSalesF3Browse: this.DefaultBankSalesF3Browse,
			DefaultPurchaseF3Browse: this.DefaultPurchaseF3Browse,
			DefaultPurchaseDocumentRowF3Browse: this.DefaultPurchaseDocumentRowF3Browse,
			NewCustommersAreBuisinessesByDefault: this.NewCustommersAreBuisinessesByDefault,
			ShowSupplierFilterOnPriceListOpen: this.ShowSupplierFilterOnPriceListOpen,
			ToolbarIframe: this.ToolbarIframe.getJSON(),
			OpenModalInExternalTab: this.OpenModalInExternalTab,
			ProductSearchSortOrder: this.ProductSearchSortOrder,
			BanksOrder: this.BanksOrder
		};
	}
}